<template>
<div>
    <Card>
        <Tree :data="treeData" :render="renderContent"></Tree>
        <ModelBox :showModel.sync="showModel" :topid="topid" :fn="callbackFn" :type="type" :editFormData="editFormData" ></ModelBox>
    </Card>
    </div>
</template>

<script>
import common from '@/common/common.js';
import ModelBox from './addModel';
    export default {
        name: "goodscate",
        components: {
            ModelBox
        },
        data () {
            return {
                showModel:false,//弹框开关
                topid:0,//上级部门id，顶级部门默认0
                type:1,//弹框打开类型 1添加 2编辑
                editFormData:{},//编辑时传入的现有数据
                callbackFn:()=>{},
                treeData: [],
                buttonProps: {
                    type: 'default',
                    size: 'small',
                }
            }
        },
        methods: {
            getData () {//请求接口获取数据
                this.axios.get(this.config.urlArray.sectionsShow,{}).then((result) => {
                    common.ajaxMsg(result.data);

                    let childrenData = result.data.data;
                    let treedata = [{
                    title: '部门管理',
                    expand: true,
                    render: (h, { root, node, data }) => {
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%',
                                fontSize:'14px'
                            }
                        }, [
                            h('span', [
                                h('span', data.title)
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
                                h('Button', {
                                    props: Object.assign({}, this.buttonProps, {
                                        icon: 'ios-add',
                                        type: 'primary'
                                    }),
                                    style: {
                                        width: '64px'
                                    },
                                    on: {
                                        click: () => { this.append(data) }//添加顶级部门
                                    }
                                })
                            ])
                        ]);
                    },
                    children: childrenData
                }]

                this.treeData = treedata;


                }).catch((err) => {
                    common.msg('error','获取数据失败',()=>{})
                });

            },
            renderContent (h, { root, node, data }) {

                return h('span', {
                    style: {
                        display: 'inline-block',
                        width: '100%',
                        fontSize:'14px',
                        lineHeight:'40px',
                        borderBottom:'1px solid #ccc'
                    }
                }, [
                    h('span', [
                        h('span', data.title)
                    ]),
                    h('span', {
                        style: {
                            display: 'inline-block',
                            float: 'right',
                            marginRight: '32px'
                        }
                    }, [
                        h('span', {
                            style: {
                                marginRight: '150px',
                            }
                        },data.leader_name),
                        h('Button', {
                            props: Object.assign({}, this.buttonProps, {
                                icon: 'md-add'
                            }),
                            style: {
                                marginRight: '8px'
                            },
                            on: {
                                click: () => { this.append(data,1) }//添加子部门
                            }
                        }),
                        h('Button', {
                            props: Object.assign({}, this.buttonProps, {//
                                icon: 'ios-create-outline'
                            }),
                            style: {
                                marginRight: '8px'
                            },
                            on: {
                                click: () => { this.append(data,2) }//编辑部门
                            }
                        }),
                        h('Poptip',{
                            props:{
                               confirm:true,
                                title:'确定删除？',
                            },
                            on:{
                                'on-ok':()=>{this.remove(root, node, data)}
                            }
                        },
                        [
                            h('Button', {
                            props: Object.assign({}, this.buttonProps, {
                                icon: 'ios-remove'
                            })
                        })
                        ]
                        )

                    ])
                ]);
            },

            append (data,type) {//添加编辑部门方法
            this.topid = !data.top_id?0:data.top_id
            this.type = type
            if(type == 2){
                this.topid = !data.top_id?0:data.top_id
                this.editFormData = data
            }else{
                this.topid = !data.id?0:data.id
            }
            this.showModel = true
            this.callbackFn = () => {//回调处理
                //重新载入
                this.clearbtnStatus()
                this.showModel = false;
                this.getData();
            }
            },

            remove (root, node, data) {//删除部门方法
                if(data.children && data.children.length > 0){
                    common.msg('error','部门下有子部门，请先删除子部门',()=>{})
                    return;
                }
                this.axios.post(this.config.urlArray.sectionsDestroy,{id:data.id,merchant_id:data.merchant_id}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        //重新载入
                        this.clearbtnStatus()
                        this.getData();
                    })
                }).catch((err) => {
                     common.msg('error','删除失败',()=>{})
                })
            },
            clearbtnStatus(){ //删除后清空编辑数据 与按钮状态
                this.editFormData ={}
            }
        },
        mounted() {
            this.getData()
        },
    }
</script>


